export enum Status {
  ALL = 'all',
  ACTIVE = 'active',
  NOT_SET = 'not_set',
  TEMP_HOLD = 'temp_hold',
  PENDING_CONFIRMATION = 'pending_confirmation',
  UNSUBSCRIBED = 'unsubscribed',
  DELETED = 'deleted',
}
